import { buildAxonItem, getAxonUserData, pushAxonEvent } from '@/utils/axonTrack'

export function useAxonBeginCheckout() {
  function reportBeginCheckout(item: {
    item_id: string | number
    item_name: string
    price: string | number
  }) {
    pushAxonEvent('begin_checkout', {
      currency: 'USD',
      value: Number(item.price),
      user_data: getAxonUserData(),
      items: [buildAxonItem({ ...item, quantity: 1 })],
    })
  }

  return { reportBeginCheckout }
}
